export const THINGYAN_MISSIONS = "THINGYAN_MISSIONS";
export const THINGYAN_CONFIG_EVENT = "THINGYAN_CONFIG_EVENT";
export const THINGYAN_CHANGE_ATTEMPT_BY_BID = "THINGYAN_CHANGE_ATTEMPT_BY_BID";
export const THINGYAN_PLAY_LOTO = "THINGYAN_PLAY_LOTO";
export const THINGYAN_SET_SPIN = "THINGYAN_SET_SPIN";
export const THINGYAN_AWARD_LIST = "THINGYAN_AWARD_LIST";
export const THINGYAN_PRIZE_COLLECTION = "THINGYAN_PRIZE_COLLECTION";
export const THINGYAN_OPEN_POPUP_HISTORY = "THINGYAN_OPEN_POPUP_HISTORY";
export const THINGYAN_OPEN_POPUP_ADD_SPIN = "THINGYAN_OPEN_POPUP_ADD_SPIN";
export const THINGYAN_OPEN_POPUP_ADD_SPIN_SUPER = "THINGYAN_OPEN_POPUP_ADD_SPIN_SUPER";
export const THINGYAN_TAKE_PRIZE = "THINGYAN_TAKE_PRIZE";
export const THINGYAN_WINNER_LIST = "THINGYAN_WINNER_LIST";
export const THINGYAN_DATA_HISTORY = "THINGYAN_DATA_HISTORY";
export const THINGYAN_OPEN_POPUP_ERROR = "THINGYAN_OPEN_POPUP_ERROR"